import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Source, Layer } from "react-map-gl/mapbox";
import { useTokens } from "@gemini/core";
import { useLocation } from "@/location/hooks/useLocation";
export const PolygonSourceAndLayer = () => {
    const { "color.content.status.information.default": layerColor } = useTokens();
    const location = useLocation();
    const geometry = location === null || location === void 0 ? void 0 : location.geometry;
    if (!geometry ||
        (geometry.type !== "Polygon" && geometry.type !== "MultiPolygon")) {
        return null;
    }
    const feature = {
        type: "Feature",
        geometry: geometry,
        properties: {},
    };
    return (_jsxs(Source, { id: "polygon-source", type: "geojson", data: feature, children: [_jsx(Layer, { id: "polygon-fill", type: "fill", paint: { "fill-color": layerColor, "fill-opacity": 0.2 } }), _jsx(Layer, { id: "polygon-outline", type: "line", paint: { "line-color": layerColor, "line-width": 2 } })] }));
};
